// app-toaster.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IToasterData } from 'quangular';

@Injectable({ providedIn: 'root' })
export class QuangularToasterService {
  private toasterSubject = new BehaviorSubject<IToasterData>(null);
  toasterData$ = this.toasterSubject.asObservable();

  showToast(toasterData: IToasterData) {
    this.toasterSubject.next(toasterData);
  }
}
